import { connect } from 'react-redux';
import RegistrationForm from './RegistrationForm';
import { registerUser, updateUser } from '../../actions/session';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  registrationFailed: state.session.registrationFailed,
  registrationFailedMessage: state.session.registrationFailedMessage,
  firstName: state.session.userRegistrationData.firstName,
  lastName: state.session.userRegistrationData.lastName,
  personId: state.session.userRegistrationData.personId,
  termsOfServiceUrl: state.organization.termsOfServiceUrl,
  registrationExclusiveFields: state.organization.registrationExclusiveFields,
  relaxedSotuVerificationEnabled: state.organization.relaxedSotuVerificationEnabled,
  creationIncomplete: state.session.creationIncomplete
});

const mapDispatchToProps = dispatch => ({
  registerUser: dispatch(registerUser),
  updateUser: dispatch(updateUser)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistrationForm);



// WEBPACK FOOTER //
// ./src/containers/RegistrationForm/index.js